// Generic color palette that can be customized for each app
export const COLORS = {
  primary: "#FF6B6B",       // Warm rose/coral as main brand color
  primaryLight: "#FFB6B9",  // Lighter shade of primary
  secondary: "#FFD166",     // Soft gold accent
  dark: "#2E2E2E",          // Dark text color
  light: "#FFF9F5",         // Warm ivory background
  gray: "#9E9E9E",          // Gray text color
  success: "#4CAF50",       // Success color
  warning: "#FFC107",       // Warning color
  error: "#F44336",         // Error color
};

// You can create app-specific color palettes by extending this
// Example:
// export const APP_COLORS = {
//   ...COLORS,
//   primary: "#FF6B6B",    // Override with app-specific colors
//   primaryLight: "#FFB6B9",
// };